import React, { Suspense, lazy } from 'react'
import InactiveFlyoutProductContent from './InactiveFlyoutProductContent'
import { settingsTabs } from '../FlyOutOnboardingWrapper/settingsTabs'
import { MainTabsV2 } from '@labrav/react-components'
import { useStyles } from './FlyOut.styles'
import { Callback } from './Callback'
import { TabsRouteMapping } from './TabsRouteMapping'
import { useFlagValue } from '@labrav/flags'
import { SnackBar } from '@labrav/common'
import { FlyoutBlockPage } from '../../common/components/FlyoutBlockPage'
import { customerFormData, isProductActive } from './useFlyoutSettingsAccess'
import type { productTab } from '../FlyOutOnboardingWrapper/settingsTabs'

let productTabs: productTab[] = [
  {
    key: 'notifications',
    product: 'flyout',
    label: 'Notifications',
    path: 'notifications',
    component: lazy(() => import('./NotificationsSettings')),
    childRoutes: [
      {
        key: 'callback',
        product: 'flyout',
        label: 'Callback',
        path: 'callback',
        component: Callback,
      },
    ],
  },
]

export const FlyoutTabs: React.FC<{
  additionalTabs: productTab[]
}> = ({ additionalTabs }) => {
  const isnewNotificationsSettingsEnabled = useFlagValue(
    'newNotificationsSettings'
  )
  if (isnewNotificationsSettingsEnabled?.value) {
    productTabs = productTabs.filter(tab => tab.key !== 'notifications')
  }
  const {
    defaultSettingsTabs,
    activeTab,
    handleTabChange,
    settingsTabsForRouting,
  } = settingsTabs([...additionalTabs, ...productTabs], [])
  const { classes } = useStyles()

  const isFlyOutInActiveProducts = isProductActive('flyout')
  const partnerInviteEnabled = useFlagValue('partnerInvite')
  const customerData = customerFormData()
  const flyoutProduct = customerData.subscribedProducts.FLYOUT
  const isFlyoutSubscribed =
    !partnerInviteEnabled?.value ||
    ((flyoutProduct?.cloudProviders || []).length ?? 0 > 0)

  return !isFlyOutInActiveProducts ? (
    <InactiveFlyoutProductContent />
  ) : (
    <div data-testid="flyout-settings-page" className={classes.rootSubTabs}>
      <div className={classes.subTabsV2}>
        <MainTabsV2
          tabs={defaultSettingsTabs}
          activeTabIndex={activeTab}
          onChange={handleTabChange}
          tabsType={'secondary'}
        />
      </div>

      <Suspense fallback={<div />}>
        {isFlyoutSubscribed ? (
          <TabsRouteMapping tabsForRouting={settingsTabsForRouting} />
        ) : (
          <FlyoutBlockPage />
        )}
      </Suspense>
      <SnackBar />
    </div>
  )
}
